module.exports = __webpack_public_path__ + "img/ass_pack.d67ae267.png";